import { render } from "./AddCollegiate.vue?vue&type=template&id=cdc52db8&scoped=true"
import script from "./AddCollegiate.vue?vue&type=script&lang=js"
export * from "./AddCollegiate.vue?vue&type=script&lang=js"

import "./AddCollegiate.vue?vue&type=style&index=0&id=cdc52db8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdc52db8"]])

export default __exports__